import constants from '../lib/constants'
import { GET_ORGANIZATIONS, GET_ORGANIZATIONS_COMPLETE } from './organizations'
import { GET_DEVICES, GET_DEVICES_COMPLETE } from './devices'
import { GET_SITES, GET_SITES_COMPLETE } from './sites'
import { GET_PHARMACIES, GET_PHARMACIES_COMPLETE } from './pharmacies'
import { GET_USERS, GET_USERS_COMPLETE } from './user'
import {
  GET_CLIENTS,
  GET_CLIENTS_COMPLETE,
  SET_CLIENT_VERSION,
  SET_CLIENT_VERSION_COMPLETE,
  CREATE_CLIENT,
  CREATE_CLIENT_COMPLETE,
} from './clients'
import {
  GET_PRESCRIBER,
  GET_PRESCRIBER_COMPLETE,
  GET_PRESCRIBERS,
  GET_PRESCRIBERS_COMPLETE,
  UPLOAD_SIGNATURE,
  UPLOAD_SIGNATURE_COMPLETE,
  UPDATE_PRESCRIBER,
  UPDATE_PRESCRIBER_COMPLETE,
  GET_PRESCRIBER_SALES,
  GET_PRESCRIBER_SALES_COMPLETE
} from './prescribers'
import {
  GET_PATIENTS,
  GET_PATIENTS_COMPLETE,
} from './patients'

// Constants
// ------------------------------------

const SET_DEVICE_DEPLOYMENT_STATE = 'SET_DEVICE_DEPLOYMENT_STATE'

// Actions
// ------------------------------------
export const setDeviceDeploymentState = (deploymentState) => {
  return (dispatch, getState) => {
    dispatch({
      type    : SET_DEVICE_DEPLOYMENT_STATE,
      payload : deploymentState
    })
  }
}

export const actions = {
  setDeviceDeploymentState
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [SET_DEVICE_DEPLOYMENT_STATE] : (state, action) => {
    const deviceDeploymentState = action.payload
    return {
      ...state,
      deviceDeploymentState
    }
  },
  [GET_ORGANIZATIONS] : (state, action) => {
    return {
      ...state,
      isFetchingOrganizations: true
    }
  },
  [GET_ORGANIZATIONS_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingOrganizations: false
    }
  },
  [GET_SITES] : (state, action) => {
    return {
      ...state,
      isFetchingSites: true
    }
  },
  [GET_SITES_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingSites: false
    }
  },
  [GET_PATIENTS] : (state, action) => {
    return {
      ...state,
      isFetchingPatients: true
    }
  },
  [GET_PATIENTS_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingPatients: false
    }
  },
  [GET_DEVICES] : (state, action) => {
    return {
      ...state,
      isFetchingDevices: true
    }
  },
  [GET_DEVICES_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingDevices: false
    }
  },
  [GET_PRESCRIBER] : (state, action) => {
    return {
      ...state,
      isFetchingPrescribers: true
    }
  },
  [GET_PRESCRIBERS] : (state, action) => {
    return {
      ...state,
      isFetchingPrescribers: true
    }
  },
  [GET_PRESCRIBER_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingPrescribers: false
    }
  },
  [GET_PRESCRIBERS_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingPrescribers: false
    }
  },
  [GET_PRESCRIBER_SALES]: (state, action) => {
    return {
      ...state,
      isFetchingPrescriberSales: true
    }
  },
  [GET_PRESCRIBER_SALES_COMPLETE]: (state, action) => {
    return {
      ...state,
      isFetchingPrescriberSales: false
    }
  },
  [GET_PHARMACIES] : (state, action) => {
    return {
      ...state,
      isFetchingPharmacies: true
    }
  },
  [GET_PHARMACIES_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingPharmacies: false
    }
  },
  [GET_USERS] : (state, action) => {
    return {
      ...state,
      isFetchingUsers: true
    }
  },
  [GET_USERS_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingUsers: false
    }
  },
  [GET_CLIENTS] : (state, action) => {
    return {
      ...state,
      isFetchingClients: true
    }
  },
  [GET_CLIENTS_COMPLETE] : (state, action) => {
    return {
      ...state,
      isFetchingClients: false
    }
  },
  [SET_CLIENT_VERSION] : (state, action) => {
    return {
      ...state,
      isUpdatingClient: true
    }
  },
  [SET_CLIENT_VERSION_COMPLETE] : (state, action) => {
    return {
      ...state,
      isUpdatingClient: false
    }
  },
  [CREATE_CLIENT] : (state, action) => {
    return {
      ...state,
      isCreatingClient: true
    }
  },
  [CREATE_CLIENT_COMPLETE] : (state, action) => {
    return {
      ...state,
      isCreatingClient: false
    }
  },
  [UPLOAD_SIGNATURE] : (state, action) => {
    return {
      ...state,
      isUploadingSignature: true,
    }
  },
  [UPLOAD_SIGNATURE_COMPLETE] : (state, action) => {
    return {
      ...state,
      isUploadingSignature: false,
    }
  },
  [UPDATE_PRESCRIBER] : (state, action) => {
    return {
      ...state,
      isUpdatingPrescriber: true
    }
  },
  [UPDATE_PRESCRIBER_COMPLETE] : (state, action) => {
    return {
      ...state,
      isUpdatingPrescriber: false
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  deviceDeploymentState: constants.DEPLOYMENT_STATES.PRODUCTION,
  isFetchingOrganizations: false,
  isFetchingDevices: false,
  isFetchingPrescribers: false,
  isFetchingSites: false,
  isFetchingPharmacies: false,
  isFetchingUsers: false,
  isFetchingClients: false,
  isUpdatingClient: false,
  isCreatingClient: false,
  isUploadingSignature: false,
  isFetchingPatients: false
}
export default function uiReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/ui.js